import { Routes } from '@angular/router';
import { complianceGuard } from './auth/compliance.guard';
import { AccountsComponent } from './accounts/accounts.component';
import { AppUnavailableComponent } from './core/app-unavailable.component';
import { LandingComponent } from './core/landing.component';
import { UsersComponent } from './users/users.component';
import { HomeComponent } from './home.component';
import { UserDocumentsComponent } from './users/user-documents.component';
import { MessagesComponent } from './users/messages/messages.component';
import { MotdsComponent } from './motds/motds.component';
import { AuditTrailMonthlyStatementsDistributionComponent } from './audit-trail/monthly-statements-distribution/audit-trail-monthly-statements-distribution.component';
import { auditTrailMonthlyStatementsDistributionGuard } from './audit-trail/monthly-statements-distribution/audit-trail-monthly-statements-distribution.guard';
import { AuditTrailUserSigninsComponent } from './audit-trail/user-signins/audit-trail-user-signins.component';
import { auditTrailUserSigninsGuard } from './audit-trail/user-signins/audit-trail-user-signins.guard';
import { MappingsPendingCheckComponent } from './mappings/mappings-pending-check.component';
import { systemReadyGuard } from './shared/system-ready.guard';
import { canWriteTdRatesGuard } from './td-rates/can-write-td-rates.guard';
import { TdRatesComponent } from './td-rates/td-rates.component';
import { TdRatesBanksComponent } from './td-rates/td-rates-banks.component';
import { TdRatesFiduciariesComponent } from './td-rates/td-rates-fiduciaries.component';
import { MsalGuard } from '@azure/msal-angular';
import { AuditTrailIbPrivateOpportunitiesDistributionComponent } from './audit-trail/ib-private-opportunities-distribution/audit-trail-ib-private-opportunities-distribution.component';
import { auditTrailIbPrivateOpportunitiesDistributionGuard } from './audit-trail/ib-private-opportunities-distribution/audit-trail-ib-private-opportunities-distribution.guard';
import { AuditTrailMappingsComponent } from './audit-trail/mappings/audit-trail-mappings.component';
import { auditTrailMappingsGuard } from './audit-trail/mappings/audit-trail-mappings.guard';
import { AuditTrailTransactionNotesDistributionComponent } from './audit-trail/transaction-notes-distribution/audit-trail-transaction-notes-distribution.component';
import { auditTrailTransactionNotesDistributionGuard } from './audit-trail/transaction-notes-distribution/audit-trail-transaction-notes-distribution.guard';
import { AuditTrailUserActionsComponent } from './audit-trail/user-actions/audit-trail-user-actions.component';
import { auditTrailUserActionsGuard } from './audit-trail/user-actions/audit-trail-user-actions.guard';
import { AuditTrailTransactionNotesReconciliationComponent } from './audit-trail/transaction-notes-distribution/audit-trail-transaction-notes-reconciliation.component';

export const routes: Routes = [
  {
    path: 'accounts',
    canActivate: [MsalGuard, complianceGuard, systemReadyGuard],
    component: AccountsComponent
  },
  {
    path: 'audit-trail',
    canActivate: [MsalGuard, systemReadyGuard],
    children: [
      {
        path: 'ib-private-opportunities-distribution',
        component: AuditTrailIbPrivateOpportunitiesDistributionComponent,
        canActivate: [MsalGuard, auditTrailIbPrivateOpportunitiesDistributionGuard, systemReadyGuard]
      },
      {
        path: 'mappings',
        component: AuditTrailMappingsComponent,
        canActivate: [MsalGuard, auditTrailMappingsGuard, systemReadyGuard]
      },
      {
        path: 'monthly-statements-distribution',
        component: AuditTrailMonthlyStatementsDistributionComponent,
        canActivate: [MsalGuard, auditTrailMonthlyStatementsDistributionGuard, systemReadyGuard]
      },
      {
        path: 'transaction-notes-distribution',
        component: AuditTrailTransactionNotesDistributionComponent,
        canActivate: [MsalGuard, auditTrailTransactionNotesDistributionGuard, systemReadyGuard]
      },
      {
        path: 'transaction-notes-reconciliation',
        component: AuditTrailTransactionNotesReconciliationComponent,
        canActivate: [MsalGuard, auditTrailTransactionNotesDistributionGuard, systemReadyGuard]
      },
      {
        path: 'user-actions',
        component: AuditTrailUserActionsComponent,
        canActivate: [MsalGuard, auditTrailUserActionsGuard, systemReadyGuard]
      },
      {
        path: 'user-signins',
        component: AuditTrailUserSigninsComponent,
        canActivate: [MsalGuard, auditTrailUserSigninsGuard, systemReadyGuard]
      }
    ]
  },
  { path: 'home', component: HomeComponent },
  {
    path: 'mappings',
    children: [
      {
        path: 'pending-check',
        component: MappingsPendingCheckComponent,
        canActivate: [MsalGuard, complianceGuard, systemReadyGuard]
      }
    ]
  },
  {
    path: 'motds',
    canActivate: [MsalGuard, complianceGuard, systemReadyGuard],
    component: MotdsComponent
  },
  {
    path: 'td-rates',
    canActivate: [MsalGuard, canWriteTdRatesGuard, systemReadyGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: TdRatesComponent,
        canActivate: [MsalGuard, canWriteTdRatesGuard, systemReadyGuard]
      },
      {
        path: 'banks',
        component: TdRatesBanksComponent,
        canActivate: [MsalGuard, canWriteTdRatesGuard, systemReadyGuard]
      },
      {
        path: 'fiduciaries',
        component: TdRatesFiduciariesComponent,
        canActivate: [MsalGuard, canWriteTdRatesGuard, systemReadyGuard]
      }
    ]
  },
  {
    path: 'users',
    canActivate: [MsalGuard, complianceGuard, systemReadyGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: UsersComponent,
        canActivate: [MsalGuard, complianceGuard, systemReadyGuard]
      },
      { path: ':type', component: UsersComponent, canActivate: [MsalGuard, complianceGuard, systemReadyGuard] },
      {
        path: ':type/:id/documents',
        component: UserDocumentsComponent,
        canActivate: [MsalGuard, complianceGuard, systemReadyGuard]
      },
      {
        path: ':type/:id/messages',
        component: MessagesComponent,
        canActivate: [MsalGuard, complianceGuard, systemReadyGuard]
      }
    ]
  },
  { path: 'unavailable', component: AppUnavailableComponent },
  { path: '', pathMatch: 'full', component: LandingComponent, canActivate: [MsalGuard] }
];
